export interface IMainNavigationProps {
    activePage: string;
}

export enum MainMenuUrlParams {
    home = '/almsp/u/Home/Index',
    message = '/almsp/u/Message/Index',
    announcement = '/almsp/u/Announcement/Index',
    forum = '/almsp/u/Forum/Index',
    course = '/almsp/u/course',
    calendar = '/almsp/calendar',
    question = '/almsp/question/index',
    file = '/almsp/file/fileexplorer',
    reports = '/almsp/u/Reports/Index',
    helpdesk ='/almsp/u/helpdesk/index',
    adminReport = '/almsp/u/report',
    adminSurvey ='/almsp/u/survey',
    adminAnnouncement ='/almsp/u/announcement',
    adminMessage ='/almsp/u/message',
    adminForum ='/almsp/u/forum',
    adminHelpdesk ='/almsp/u/helpdesk',
    cockpit = '/almsp/u/Home/Cockpit',
    stats = '/almsp/u/Stats',
    settings = '/almsp/u/settingsui',
    modules = '/almsp/u/modulesui'
}

export enum MainMenuParameters {
    home = 'r_menu_home',
    cockpit = 'r_menu_cockpit',
    message = 'r_menu_messages',
    myCourses = 'r_menu_my_courses',
    tools = 'r_menu_communication_tools',
    questionBank = 'r_menu_question_bank',
    forum = 'r_menu_forum',
    myFiles = 'r_menu_my_files',
    calendar = 'r_menu_calendar',
    reports = 'r_menu_report',
    announcements = 'r_menu_announcements',
    gradeChart = 'r_menu_grade_chart',
    myDocuments = 'r_menu_my_documents',
    helpdesk ='r_menu_helpdesk',
    adminReport = 'r_menu_report',
    adminSurvey ='r_menu_survey',
    adminAnnouncement = 'r_menu_announcements_admin',
    adminMessage = 'r_menu_messages_admin',
    adminForum = 'r_menu_forum_admin',
    adminHelpdesk = 'r_menu_helpdesk_admin',
    stats = 'r_menu_stats'
}

export enum AddedStaticLinkTypes {
    normal = 'Normal',
    newWindow = 'NewWindow',
    current = 'Current',
}
